import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  Box,
  TextField,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

interface TempPasswordDialogProps {
  open: boolean;
  tempPassword: string;
  onClose: () => void;
}

const TempPasswordDialog = ({
  open,
  tempPassword,
  onClose,
}: TempPasswordDialogProps) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(tempPassword);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Temporary Password</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
          Please copy this temporary password and share it securely with the
          user. It will not be shown again.
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <TextField
            fullWidth
            value={tempPassword}
            InputProps={{
              readOnly: true,
            }}
            size="small"
          />
          <IconButton onClick={handleCopy} color={copied ? "success" : "default"}>
            <ContentCopyIcon />
          </IconButton>
        </Box>
        {copied && (
          <Typography variant="caption" color="success.main" sx={{ mt: 1 }}>
            Copied to clipboard!
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TempPasswordDialog;
